import { Col as C, Form, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import React, { useMemo } from 'react'
import { CustomSelect as Select } from 'src/components/common/select'
import { useGetCategoryOptions } from 'src/hooks/useGetCategoryOptions'
import { useGetUserOptionsByRole } from 'src/hooks/useGetUserOptionsByRole'
import { CATEGORY_TYPE, GENDERS, translateConst, USER_ROLES_ENUM } from 'src/libs/constant'
import { FLYER_GRADE, MOVERS_GRADE, STARTERS_GRADE } from 'src/libs/constant/grade'
import SelectTeacherLevel from 'src/components/common/SelectTeacherLevel'
import SelectDensity from 'src/components/common/SelectDensity'
import RangePickerCustom from 'src/components/common/input/RangePickerCustom'
import RefreshButton from 'src/components/common/button/RefreshButton'

export function FilterTeacher ({
  isDisabledFilterGrade,
  isDisabledFilterSchedueleType,
  form,
  onChangeFilterField,
  teacherClassify,
  onReset
}) {
  const { t } = useTranslation()

  const regionOptions = useGetCategoryOptions(CATEGORY_TYPE.REGION)
  const violationLevelOptions = useGetCategoryOptions(CATEGORY_TYPE.VIOLATION_LEVEL)

  const gradeOptions = useMemo(() => {
    return [
      {
        label: 'Starters',
        value: JSON.stringify(STARTERS_GRADE)
      },
      {
        label: 'Movers',
        value: JSON.stringify(MOVERS_GRADE)
      },
      {
        label: 'Flyers',
        value: JSON.stringify(FLYER_GRADE)
      }
    ]
  }, [t])

  const sessionTypeOptions = [
    {
      value: 'REGULAR',
      label: 'REGULAR'
    },
    {
      value: 'BACKUP',
      label: 'BACKUP'
    }
  ]

  const teacherClassifyOption = useMemo(() => {
    return teacherClassify?.content.map(val => {
      return {
        value: val?.id,
        label: val?.name
      }
    }) || []
  }, [teacherClassify])

  const teacherOptions = useGetUserOptionsByRole(USER_ROLES_ENUM.EMPLOYEE_TEACHER)

  const [genderOptions] =
    useMemo(() => {
      return [
        translateConst(t, GENDERS, 'gender')
      ]
    }, [])

  return (
    <Form
      form={form}
      name='search_schedule_class'
      initialValues={{}}
      onFieldsChange={onChangeFilterField}
      preserve={false}
    >
      <Row gutter={12}>
        <Col>
          <Form.Item name='regionIds'>
            <Select options={regionOptions} allowClear placeholder={t('page.class.label.region')} unSorted />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name='teacherGender'>
            <Select options={genderOptions} allowClear placeholder={t('page.session.placeholder.gender')} unSorted />
          </Form.Item>
        </Col>
        {!isDisabledFilterGrade && (
          <Col>
            <Form.Item name='grades'>
              <Select options={gradeOptions} allowClear placeholder={t('common.label.teacher_grade')} unSorted />
            </Form.Item>
          </Col>
        )}
        {!isDisabledFilterSchedueleType && (
          <Col>
            <Form.Item name='scheduleType'>
              <Select options={sessionTypeOptions} allowClear placeholder={t('page.session.placeholder.session_type')}
                      unSorted />
            </Form.Item>
          </Col>
        )}
        <Col>
          <Form.Item name='teacherId'>
            <Select options={teacherOptions} allowClear placeholder={t('page.class.label.teacher')} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name='teacherClassifyIds'>
            <Select options={teacherClassifyOption} allowClear placeholder={t('page.teacher.text.tutor_file')} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name='violationLevelId'>
            <Select options={violationLevelOptions} allowClear placeholder={t('page.teacher.text.violation_level')} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name='teacherLevelId'>
            <SelectTeacherLevel />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name='density'>
            <SelectDensity />
          </Form.Item>
        </Col>
        <C xs={18} sm={14} md={14} lg={8} xxl={8}>
          <RangePickerCustom
            name='hireDate'
            placeholder='Ngày nhận việc'
          />
        </C>
        <C lg={2}>
          <RefreshButton onReset={onReset} />
        </C>
      </Row>
    </Form>
  )
}

function Col ({ children, ...rest }) {
  return <C xs={8} sm={6} md={6} lg={4} xxl={4} {...rest}>{children}</C>
}
